import type { FC } from "react";

import { proNavigator } from "single-spa/react-app/ProNavigator";

import GenericWidgetTable from "../GenericWidgetTable/GenericWidgetTable";

import { useTopPaidLandingPages } from "./hooks/useTopPaidLandingPages";

const TopPaidLandingPages: FC = () => {
    const { switcherConfig, tableProps, footerButtonsConfig } = useTopPaidLandingPages();

    return (
        <div data-automation="TopPaidLandingPages">
            <GenericWidgetTable
                title={"website.analysis.search.overview.top.paid.landing.pages.title"}
                tooltip={"website.analysis.search.overview.top.paid.landing.pages.tooltip"}
                footerButtonsConfig={proNavigator.isSalesSolution() ? undefined : footerButtonsConfig}
                switcherConfig={switcherConfig}
                tableProps={tableProps}
                contentHeight={220}
                minHeight={376}
            />
        </div>
    );
};

export default TopPaidLandingPages;
